"use client";

import React from 'react';
import { Building2, CreditCard, Mail, Phone } from 'lucide-react';
import { useTranslation } from 'react-i18next';

export const Footer = () => {
  const { t } = useTranslation();

  return (
    <footer className="bg-slate-950/80 border-t border-white/10 py-12">
      <div className="container mx-auto px-4">
        <div className="grid md:grid-cols-3 gap-8 mb-12">
          <div className="flex flex-col items-center text-center">
            <div className="flex items-center space-x-3 mb-4">
              <Building2 className="w-5 h-5 text-blue-300 flex-shrink-0" />
              <div>
                <p className="text-white font-semibold">Market Engine Michał Mierzejewski</p>
                <p className="text-blue-200/80 text-sm">NIP: 8351621513 | REGON: 541142920</p>
                <p className="text-blue-200/80 text-sm">Białogórne 5, 96-230 Biała Rawska</p>
              </div>
            </div>
            <div className="flex items-center space-x-3">
              <CreditCard className="w-5 h-5 text-blue-300 flex-shrink-0" />
              <div>
                <p className="text-white font-semibold">{t('footer.accountNumber')}</p>
                <p className="text-blue-200/80 text-sm">63 1140 2004 0000 3102 8564 1385</p>
              </div>
            </div>
          </div>

          <div className="flex flex-col items-center text-center">
            <h4 className="text-white font-semibold mb-4">{t('footer.usefulResources')}</h4>
            <ul className="space-y-2">
              <li>
                <a
                  href="https://react.dev"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-blue-200/80 hover:text-blue-300 transition-colors"
                >
                  React
                </a>
              </li>
              <li>
                <a
                  href="https://nextjs.org"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-blue-200/80 hover:text-blue-300 transition-colors"
                >
                  Next.js
                </a>
              </li>
              <li>
                <a
                  href="https://tailwindcss.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-blue-200/80 hover:text-blue-300 transition-colors"
                >
                  Tailwind CSS
                </a>
              </li>
            </ul>
          </div>

          <div className="flex flex-col items-center text-center">
            <h4 className="text-white font-semibold mb-4">{t('footer.connectWithUs')}</h4>
            <div className="flex flex-col space-y-3">
              <a
                href="mailto:biuro@marketengine.pl"
                className="flex items-center space-x-2 text-blue-200/80 hover:text-blue-300 transition-colors"
              >
                <Mail className="w-5 h-5" />
                <span>biuro@marketengine.pl</span>
              </a>
              <a
                href="tel:+48507456292"
                className="flex items-center space-x-2 text-blue-200/80 hover:text-blue-300 transition-colors"
              >
                <Phone className="w-5 h-5" />
                <span>507 456 292</span>
              </a>
            </div>
          </div>
        </div>
        
        <div className="text-center border-t border-white/10 pt-8">
          <p className="text-blue-200/60 text-sm">{t('footer.rights')}</p>
        </div>
      </div>
    </footer>
  );
};
